export const environment = {
  production: false,
  apiUrl: 'https://testapi.pescaincloud.it',
  isTest: true,
  isDemo: false,
  enableBugsnag: true,
};
